module.exports = __webpack_public_path__ + "img/30.63e7ee07.png";